import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { TAccessStatus } from '@/shared/models/access-status';

import { Tag } from '../Tag';

interface IStatusProps {
  status: TAccessStatus;
}

const STATUSES = defineMessages<TAccessStatus>({
  active: {
    defaultMessage: 'active',
    id: 'bNWux8',
    description: 'Access status',
  },
  expired_docs: {
    defaultMessage: 'documents',
    id: 'e+ENqk',
    description: 'Access status: expired_docs',
  },
  pending: {
    defaultMessage: 'pending',
    id: 'plvf9F',
    description: 'Access status',
  },
  rejected: {
    defaultMessage: 'rejected',
    id: 'RHIKJX',
    description: 'Access status',
  },
  blocked: {
    defaultMessage: 'blocked',
    id: 'gocuNX',
    description: 'Access status',
  },
  partner_blocked: {
    defaultMessage: 'partner',
    id: 'R2Re3R',
    description: 'Access status: partner_blocked',
  },
  new_partner: {
    defaultMessage: 'new',
    id: 'RoBz7U',
    description: 'Access status: new_partner',
  },
  end_of_life: {
    defaultMessage: 'end of life',
    id: 'bwurwl',
    description: 'Access status: end_of_life',
  },
  failed_tests: {
    defaultMessage: 'failed tests',
    id: 's0Lykb',
    description: 'Access status: failed_tests',
  },
  // Offboarded chauffeurs are intentionally displayed as blocked
  to_be_offboarded: {
    defaultMessage: 'blocked',
    id: 'global_access_status_to_be_offboarded',
    description: 'Access status: to_be_offboarded',
  },
  offboarded: {
    defaultMessage: 'blocked',
    id: 'global_access_status_offboarded',
    description: 'Access status: offboarded',
  },
});

const AccessStatus = ({ status }: IStatusProps) => {
  const intl = useIntl();

  return (
    <Tag
      intent={(() => {
        switch (status) {
          case 'blocked':
          case 'expired_docs':
          case 'partner_blocked':
          case 'failed_tests':
          case 'to_be_offboarded':
          case 'offboarded':
            return 'danger';
          case 'active':
            return 'success';
          default:
            return 'default';
        }
      })()}
    >
      {intl.formatMessage(STATUSES[status])}
    </Tag>
  );
};

export { AccessStatus };
